module.exports = __webpack_public_path__ + "static/media/zon.29a6c92e.png";